'use strict';
angular.module('TurneroApp').component('coCiudadanohome', {
	bindings: {
		usuario: '<'
	},
	controller: ['$window', 'turnosService', '$state', '$rootScope', 'utilsService', 'TurneroAppConstant',
  function ($window, turnosService, $state, $rootScope, utilsService, TurneroAppConstant) {
  	var ctrl = this;

  	ctrl.limpiarMemoria = function () {
  		$rootScope.$broadcast('esHome', true);
        $rootScope.$broadcast('esCalendario', false);
        $rootScope.$broadcast('esTasaRetributiva', false);
  	}


  	ctrl.$onInit = function () {
            if (!utilsService.matchRuleShort($state.current.url, $rootScope.urlHostServer, "turnosPortal?*")) {
  			ctrl.limpiarMemoria();
  		}

  	};


  }],
	template: require('./ciudadanoHome.html')
});



// WEBPACK FOOTER //
// ./app/components/turnos/turnosOnline/ciudadanohomeComponent.js